import Vue from 'vue';
import Component from 'vue-class-component';
import TubeLabel from '@/lib/form/label/Label.vue';

@Component({
  name: 't-checkbox',
  props: {
    label: {
      type: String,
      default: ''
    },

    name: {
      type: String
    },

    required: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    value: {
      type: [Boolean, String, Number],
      default: true
    },

    unCheckedValue: {
      type: [Boolean, String, Number],
      default: false
    },

    checked: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    invalidMessage: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: 'regular'
    },

    color: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    checkedIcon: {
      type: String
    },

    uncheckedIcon: {
      type: String
    },

    imgSrc: {
      type: String
    }
  },
  model: {
    prop: 'checked',
    event: 'update'
  },
  components: {
    TubeLabel
  }
})
export default class TCheckbox extends Vue {
  disabled!: boolean;
  required!: boolean;
  unCheckedValue!: string | boolean;
  checked!: boolean;
  readonly!: boolean;
  size!: string;
  color!: string;
  name!: string;
  invalidMessage!: string;
  value!: string | boolean;

  constructor() {
    super();
  }

  get classList() {
    return {
      't-checkbox': true,
      't-checkbox--disabled': this.disabled,
      [`t-checkbox--${this.size}`]: this.size,
      [`t-checkbox--${this.color}`]: this.color
    };
  }

  get canEmitEvents(): boolean {
    return !(this.disabled || this.readonly);
  }

  change({ target: { checked, value } }) {
    if (this.canEmitEvents) {
      this.$emit('update', checked, value, this.name);
    }
  }
}
